module.exports = __webpack_public_path__ + "static/media/icon_lighting.6e03790d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon_lighting.svg
// module id = 85
// module chunks = 0